'use client'

import type { PublicationDraft } from '@/lib/publications/types'
import {
  Badge,
  FullBleedImage,
  HandmadeFrame,
  SafeText,
  clampIndex,
  getCopy,
  getDesign,
  getSectorFonts,
  getVisual,
  type HandmadePackProps,
} from '../shared/HandmadePackCore'

const images = ['https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1556761175-4b46a572b786?q=80&w=1200&auto=format&fit=crop']

const fallbackSlides = [{eyebrow:'PRUEBA',headline:'El resultado habla por sí solo',subheadline:'Un caso se vuelve poderoso cuando muestra contexto y evidencia.',cta:'Ver caso',bullets:['Situación inicial', 'Decisión', 'Resultado']},{eyebrow:'CITA',headline:'“No pensé que fuera posible tan rápido”',subheadline:'Usa una frase humana y una métrica clara para generar confianza.',cta:'Conocer más',bullets:['Objeción', 'Experiencia', 'Cambio']},{eyebrow:'CIERRE',headline:'Esto también puede ser tu punto de partida',subheadline:'Un testimonio debe abrir posibilidad, no sonar perfecto.',cta:'Quiero empezar',bullets:['Prueba real', 'Proceso claro', 'Acción simple']}]

export default function EventTestimonialPack({ draft, activeIndex, onActiveIndexChange }: HandmadePackProps) {
  const total = fallbackSlides.length
  const idx = clampIndex(activeIndex, total)
  const design = getDesign(draft, '#FFB000')
  const fonts = getSectorFonts('events')
  const copy = getCopy(draft, idx, fallbackSlides[idx])
  const visual = getVisual(draft, idx, images[idx % images.length], { overlay: 'black', opacity: 0.62, blur: false })

  const accent = design.accent || '#FFB000'
  const accent2 = design.accentDeep || '#8B5CF6'
  const background = '#100B1F'
  const surface = '#19122D'
  const text = '#FFFFFF'
  const muted = 'rgba(255,255,255,0.66)'
  const border = 'rgba(255,255,255,0.16)'

  return (
    <HandmadeFrame activeIndex={idx} total={total} onActiveIndexChange={onActiveIndexChange} text={"#fff"}>

      <div className="absolute inset-0" style={{ background }} />
      <FullBleedImage {...visual} />
      <div className="absolute inset-0" style={{ background: idx === 0 ? 'radial-gradient(circle at 75% 25%, rgba(255,176,0,0.42), transparent 34%), linear-gradient(90deg, rgba(16,11,31,0.98), rgba(16,11,31,0.74), rgba(16,11,31,0.42))' : 'linear-gradient(180deg, rgba(16,11,31,0.92), rgba(16,11,31,0.84))' }} />
      <div className="absolute left-8 top-8 flex items-center gap-3"><div className="h-12 w-12 rounded-full" style={{ background: accent }} /><Badge color="#fff" background="rgba(255,255,255,0.13)">{copy.eyebrow || 'SESSION'}</Badge></div>
      <div className="absolute left-8 right-8 top-[28%]"><SafeText className="max-w-[82%] text-[clamp(40px,10vw,74px)] font-black uppercase leading-[0.88] tracking-[-0.06em]" style={{ color: '#fff', fontFamily: fonts.heading }}>{copy.headline}</SafeText><SafeText className="mt-5 max-w-[430px] text-[17px] leading-[1.45]" style={{ color: 'rgba(255,255,255,0.78)', fontFamily: fonts.body }}>{copy.subheadline}</SafeText></div>
      <div className="absolute bottom-9 left-8 right-8 grid grid-cols-3 gap-2">{copy.bullets.slice(0,3).map((item: string, i: number) => <div key={i} className="rounded-2xl border border-white/15 bg-white/10 p-3 text-[12px] font-bold text-white backdrop-blur" style={{ fontFamily: fonts.label }}>{item}</div>)}</div>

    </HandmadeFrame>
  )
}
